import React from 'react';

function Sidebar() {
  return (
    <aside className="sidebar">
      <div className="sidebar-panel">
        <p className="sidebar-title">Workspace</p>
        <div className="sidebar-nav">
          <a href="/dashboard" className="sidebar-link">Executive Overview</a>
          <a href="/" className="sidebar-link">Profile Landing</a>
          <a href="#delivery-trend" className="sidebar-link">Delivery Trend</a>
          <a href="#impact-metrics" className="sidebar-link">Impact Metrics</a>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
